import axios from 'axios';
import Vue from 'vue';

const state = {
    donation_data: null,
    fetching_donations: false,

    donation_options: null,
    fetching_options: false,

    donation_settings: null,
    fetching_donation_settings: false,

    progress_bar: {
        current_step: 0,
        steps: [
            {label: 'Your Donation'},
            {label: 'Your Details'},
            {label: 'Payment'},
        ]
    },

    donation_details: null,
    donation_payment: null
};

const getters = {
    donationData: (state) => state.donation_data,
    fetchingDonations: (state) => state.fetching_donations,
    donationOptions: (state) => state.donation_options,
    fetchingOptions: (state) => state.fetching_options,
    donationSettings: (state) => state.donation_settings,
    fetchingDonationSettings: (state) => state.fetching_donation_settings,
    progressBar: (state) => state.progress_bar,

    donationDetails: (state) => state.donation_details,

    target: (state) => {
        return state.donation_data
                ? state.donation_data.target : 0;
    },
    totalDonationsValue: (state) => {
        if (!state.donation_data || !state.donation_data.donations) {
            return 0;
        }

        let total = 0;
        for (let donation of state.donation_data.donations) {
            total += parseFloat(donation.amount);
        }
        return total;
    },

    hasDonationAmounts: (state) => {
        return (
            state.donation_options &&
            (state.donation_options.amounts || state.donation_options.custom_amount)
        )
    },

    donationAmounts: (state) => {
        return (state.donation_options && state.donation_options.amounts)
            ? state.donation_options.amounts : null;
    },
    donationCustomAmount: (state) => {
        return (state.donation_options && state.donation_options.custom_amount)
            ? state.donation_options.custom_amount : null;
    }
};

const actions = {
    donations({commit}, {postId}) {
        commit('FETCHING_DONATIONS', true);
        return new Promise((resolve, reject) => {
            axios
                .get(`/api/post/${postId}/donations`)
                .then(({ data }) => {
                    commit('SET_DONATIONS', data);
                    commit('FETCHING_DONATIONS', false);
                    return resolve(data);
                })
                .catch((error) => {
                    commit('FETCHING_DONATIONS', false);
                    return reject();
                });
        });
    },

    donationOptions({commit}, {postId}) {
        commit('FETCHING_OPTIONS', true);
        return new Promise((resolve, reject) => {
            axios
                .get(`/api/post/${postId}/donations/options`)
                .then(({ data }) => {
                    commit('SET_OPTIONS', data);
                    commit('FETCHING_OPTIONS', false);
                    return resolve(data);
                })
                .catch((error) => {
                    commit('FETCHING_OPTIONS', false);
                    return reject();
                });
        });
    },

    donationSettings({commit}) {
        commit('FETCHING_DONATION_SETTINGS', true);
        return new Promise((resolve, reject) => {
            axios
                .get(`/api/settings/donations`)
                .then(({ data }) => {
                    commit('SET_DONATION_SETTINGS', data);
                    commit('FETCHING_DONATION_SETTINGS', false);
                    return resolve(data);
                })
                .catch((error) => {
                    commit('FETCHING_DONATION_SETTINGS', false);
                    return reject();
                });
        });
    },

    preserveDetails({commit}, form) {
        commit('PRESERVE_FORM_DETAILS', form);
    },

    resetDonationData({commit}) {
        commit('RESET_DONATION_DATA');
    },

    syncLastDonation({commit}, {amount, description}) {
        commit('SYNC_LAST_DONATION', {amount, description});
    },

    changeStep({commit}, {step}) {
        commit('CHANGE_STEP',step);
    }
};

const mutations = {
    SET_DONATIONS(state, data) {
        state.donation_data = data;
    },
    FETCHING_DONATIONS(state, value) {
        state.fetching_donations = value;
    },
    SET_OPTIONS(state, data) {
        state.donation_options = data;
    },
    FETCHING_OPTIONS(state, value) {
        state.fetching_options = value;
    },
    SET_DONATION_SETTINGS(state, data) {
        state.donation_settings = data;
    },
    FETCHING_DONATION_SETTINGS(state, value) {
        state.fetching_donation_settings = value;
    },
    PRESERVE_FORM_DETAILS(state, form) {
        state.donation_details = form;
    },
    RESET_DONATION_DATA(state) {
        state.donation_details = null;
        state.donation_payment = null;
    },
    SYNC_LAST_DONATION(state, {amount, description}) {
        if (state.donation_data && state.donation_data.donations) {
            let newIndex = state.donation_data.donations.length;
            Vue.set(state.donation_data.donations, newIndex, []);
            Vue.set(state.donation_data.donations[newIndex], 'amount', amount);
            Vue.set(state.donation_data.donations[newIndex], 'description', description);
        }
    },
    CHANGE_STEP(state, value) {
        state.progress_bar.current_step = value;
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
